/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

import { Button } from '@/primitives/Button';

import './CreateAlertWizardFooter.css';

type CreateAlertWizardFooterProps = {
  onNext: () => void;
  onPrevious?: () => void;
  nextLabel: string;
  previousLabel?: string;
  nextDisabled?: boolean;
  loading?: boolean;
};

export function CreateAlertWizardFooter({
  onNext,
  onPrevious,
  nextLabel,
  previousLabel,
  nextDisabled,
  loading,
}: CreateAlertWizardFooterProps) {
  return (
    <div className="alert-wizard-footer">
      <div>
        {onPrevious && (
          <Button icon={<ArrowLeftOutlined />} dataTestId="alert-wizard-previous" type="default" onClick={onPrevious}>
            {previousLabel}
          </Button>
        )}
      </div>
      <Button dataTestId="alert-wizard-next" type="primary" onClick={onNext} disabled={nextDisabled} loading={loading}>
        {nextLabel} <ArrowRightOutlined />
      </Button>
    </div>
  );
}
